import styled from 'styled-components';
import { InputStyles } from '../Textbox/Textbox.styles';
const Input = styled.textarea `
  ${InputStyles};
  min-height: 150px;
`;
export const TextAreaStyles = {
    Input,
};
